export default __webpack_public_path__ + "static/media/intro-comic.f54523c2.jpg";